export default {
  KEY: "AIzaSyB5C20rhOoRDtHpHIPbxQsvOoirqyGf6ac",
};
